"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseType = void 0;
const moment_1 = __importDefault(require("moment"));
function parseBoolean(value) {
    value = value.toLowerCase();
    if (value === 'true')
        return true;
    if (value === 'false')
        return false;
    throw `Invalid value '${value}'`;
}
function parseList(value) {
    return value;
}
function parseNumber(value) {
    const x = parseFloat(value);
    return x;
}
function parseDate(value) {
    const m = (0, moment_1.default)(value);
    if (!m.isValid())
        throw `Invalid date`;
    return m.toDate();
}
function parseType(type, value) {
    value = value.trim();
    if (value === '')
        return null;
    switch (type) {
        case "boolean":
            return parseBoolean(value);
        case "list":
            return parseList(value);
        case "number":
            return parseNumber(value);
        case "date":
            return parseDate(value);
    }
}
exports.parseType = parseType;
